import { DEFAULT_PAGE_SIZE_PLANNER_ASSIGNMENTS } from '@/lib/constants/pagination';
import { PaginatedResponse } from '@/modules/common';
import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

import { GetAssignmentsForPlannerByMemberRequest, PlannerMemberResponse } from '../types/dto';

export const getAssignmentsByMember = async ({
  filters,
  pagination,
  utilizationBasedOn,
  utilizationFilters,
  ignorePlaceholdersForGroup,
}: GetAssignmentsForPlannerByMemberRequest) => {
  const endpoint = '/api/assignments/planner/by-member/search';

  const apiData = await withApiErrorHandler(endpoint, ApiErrorCode.ASSIGNMENT_LOAD_FAILED, () =>
    axiosInstance.post<{
      data: PaginatedResponse<PlannerMemberResponse>;
      error?: { status: number; message: string; code: string };
    }>(endpoint, {
      filters,
      utilizationBasedOn,
      utilizationFilters,
      ignorePlaceholdersForGroup,
      pagination: pagination ?? {
        pageSize: DEFAULT_PAGE_SIZE_PLANNER_ASSIGNMENTS,
        cursor: null,
      },
    })
  );

  return new PaginatedResponse({
    items: apiData.items ?? [],
    pagination: apiData.pagination,
  });
};
